import { message } from 'antd';
import { config } from 'util/config';
import { httpClient, uploadClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getJobTypeDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });

  httpClient
    .get('Admin/JobType/GetSelectOptionList?moduleId=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          dataSource = dataSource.filter(item => item.Value !== 0);

          let componentDataSource = { ...sectionComponent.state.componentDataSource };
          componentDataSource.JobTypeId = dataSource;
          sectionComponent.setState({ componentDataSource });

          if (dataSource.length > 0) {
            setTimeout(() => {
              getSectionDataByDefault({ sectionName, parameter: dataSource[0].Value, sectionComponent, pageComponent, uie });
            }, config.setTimeoutMilliSecond);
          } else {
            let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
            componentDefaultValue.JobTypeId = null;
            let searchParameter = sectionComponent.state.searchParameter;
            searchParameter.jobTypeId = 0;
            sectionComponent.setState({ searchParameter, componentDefaultValue });
            setTimeout(() => {
              sectionComponent.getSectionDataByDefault();
            }, config.setTimeoutMilliSecond);
          }
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue.JobTypeId = parameter;
  let searchParameter = sectionComponent.state.searchParameter;
  searchParameter.jobTypeId = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let defaultFormData = { ...pageComponent.state.defaultFormData };
  defaultFormData.jobTypeId = parameter;
  pageComponent.setState({ defaultFormData });

  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

export function formatData({ sectionComponent, parameter, pageComponent } = {}) {
  let stepsList = []
  parameter.map(k => {
    k.IconActiveUrl = 'data:image/svg+xml;base64, ' + k.IconActive;
    k.IconInactiveUrl = 'data:image/svg+xml;base64, ' + k.IconInactive;
    stepsList.push({
      title: k.Name,
      description: k.Description,
      finish: k.IconActiveUrl,
      process: k.IconInactiveUrl,
    })
  })
  // 预览步骤更新后，按当前 Preview Section 的实际宽度重新计算展示方向。
  pageComponent.setState({ steps: stepsList }, pageComponent.updateStepperDirection)

}

export function customFormOnSubmit({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let formData = new FormData();
  let values = sectionComponent.customForm.current?.formRef.current?.getFieldsValue();
  for (let key in values) {
    if (values[key] !== undefined && values[key] !== null) {
      if (key !== 'IconActive' && key !== 'IconInactive') {
        formData.append(key, values[key]);
      }
    }
  }
  formData.append('moduleId', sectionComponent.props.defaultFormData.moduleId);
  formData.append('jobTypeId', sectionComponent.props.defaultFormData.jobTypeId);
  if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.iconActiveFileList.map((file) => {
      formData.append('IconActive', file);
    })
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconActivePreview: null });

    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.iconInactiveFileList.map((file) => {
      formData.append('IconInactive', file);
    })
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconInactivePreview: null });

  }
  switch (sectionComponent.state.componentType) {
    case 'Create':
      uploadClient
        .post('Admin/JobStatusStepper', formData)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ showModal: false, submitting: false });
            setTimeout(() => {
              sectionComponent.customForm.current?.formRef.current?.resetFields();
              sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ IconActive: null, IconInactive: null });
              sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconActiveFileList: [], iconActivePreview: null });
              sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconInactiveFileList: [], iconInactivePreview: null });
              sectionComponent.getSectionDataByDefault();
            }, config.setTimeoutMilliSecond);
          } else {
            globalFunction.handleResultError(data, pageComponent);
            sectionComponent.setState({ submitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ submitting: false });
        });
      break;
    case 'Edit':
      formData.append('key', sectionComponent.customForm.current?.state.currentDataKey);
      formData.append('CompanyId', sectionComponent.props.companyId);
      uploadClient
        .put('Admin/JobStatusStepper', formData)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ showModal: false, submitting: false });
            sectionComponent.customForm.current?.formRef.current?.resetFields();
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ IconActive: null, IconInactive: null });
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconActiveFileList: [], iconActivePreview: null });
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconInactiveFileList: [], iconInactivePreview: null });
            sectionComponent.getSectionDataByDefault();
          } else {
            globalFunction.handleResultError(data, pageComponent);
            sectionComponent.setState({ submitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ submitting: false });
        });
      break;
  }
}

export function cancelCustomForm({ parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.setState({ showModal: false });
  sectionComponent.customForm.current?.formRef.current?.resetFields();
  sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ IconActive: null, IconInactive: null });
  if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconActiveFileList: [], iconActivePreview: null });
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconInactiveFileList: [], iconInactivePreview: null });
  }
  setTimeout(() => {
    sectionComponent.setState({ componentType: null });
  }, config.setTimeoutMilliSecond);
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue({
            Name: data.data.Name,
            Description: data.data.Description,
            ModuleId: data.data.ModuleId,
            CompanyId: data.data.CompanyId,
            JobStatusStepperId: data.data.JobStatusStepperId,
            key: data.data.key,
          });
          sectionComponent.customForm.current?.setState({ formData: data.data, currentDataKey: data.data.key });
          let iconActiveFileList = [];
          let iconInactiveFileList = [];
          if (data.data.IconActive !== null) {

            let IconActiveString = window.atob(data.data.IconActive);
            let IconActiveLen = IconActiveString.length;
            let bytes = new Uint8Array(IconActiveLen);
            for (let i = 0; i < IconActiveLen; i++) {
              let ascii = IconActiveString.charCodeAt(i);
              bytes[i] = ascii;
            }

            let blob = new Blob([bytes], { type: 'application/octet-stream' });
            let file = new File([blob], 'active.svg', { type: 'application/octet-stream', lastModified: Date.now() });
            iconActiveFileList.push(file);
          }
          if (data.data.IconInactive !== null) {

            let IconInactiveString = window.atob(data.data.IconInactive);
            let IconInactiveLen = IconInactiveString.length;
            let bytes = new Uint8Array(IconInactiveLen);
            for (let i = 0; i < IconInactiveLen; i++) {
              let ascii = IconInactiveString.charCodeAt(i);
              bytes[i] = ascii;
            }

            let blob = new Blob([bytes], { type: 'application/octet-stream' });
            let file = new File([blob], 'Inactive.svg', { type: 'application/octet-stream', lastModified: Date.now() });
            iconInactiveFileList.push(file);
          }
          setTimeout(() => {
            if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
              sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconActiveFileList, iconActivePreview: data.data.IconActive });
              sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ iconInactiveFileList, iconInactivePreview: data.data.IconInactive });
            }
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

export function sortJobStatusStepperRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.getSectionDataByDefault();
}

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (pageComponent.state.defaultFormData.moduleId != undefined && pageComponent.state.defaultFormData.jobTypeId != undefined) {
    sectionComponent.setState({ showModal: true, componentType: 'Create' });
  }
}
